import { render, staticRenderFns } from "./RightPanel.vue?vue&type=template&id=d1bd18b8&scoped=true&"
import script from "./RightPanel.vue?vue&type=script&lang=js&"
export * from "./RightPanel.vue?vue&type=script&lang=js&"
import style0 from "./RightPanel.vue?vue&type=style&index=0&id=d1bd18b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1bd18b8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\CompanyProject\\HF-IM-sub-design\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d1bd18b8')) {
      api.createRecord('d1bd18b8', component.options)
    } else {
      api.reload('d1bd18b8', component.options)
    }
    module.hot.accept("./RightPanel.vue?vue&type=template&id=d1bd18b8&scoped=true&", function () {
      api.rerender('d1bd18b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/createFlow/build/RightPanel.vue"
export default component.exports